import { Routes } from "@angular/router";
import { LoginComponent } from "./components/login/login.component";


export const AuthRoutes: Routes = [
  {
    path: "",
    component: LoginComponent
  }
];